import { render, staticRenderFns } from "./Cellars.vue?vue&type=template&id=8c143aee"
import script from "./Cellars.vue?vue&type=script&lang=js"
export * from "./Cellars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports